// extracted by mini-css-extract-plugin
export default {"wrapper":"AlertBox_wrapper__5IZ05"};